<template>
  <!-- home v2 -->  
  <div class="home">

    <!-- overlay layers -->
    <!--<home-program></home-program>-->
    <home-proginfo  :item_info="progItemInfo"
                    @close-proginfo="closeProgInfo" 
                    v-if="isProginfoOpen"></home-proginfo>

    <home-location @close-map="closeMap" v-if="isMapOpen"></home-location>    
    <home-gallery @close-gal="closeGal" :openIndex="galOpenInex"></home-gallery>

    <speaker-info 
      @pre-speaker="preSpeaker"
      @next-speaker="nextSpeaker"
      @close-speaker="closeSpeaker" 
      :showMode="speakerMode"
      :showIndex="speakerIndex"></speaker-info>
	  
    <div :class="['msMenu',isMenuOpen ? 'msOpen' : '']">
      <div @click="isMenuOpen=false" class="closebtn"></div>  
        <ul>
          <li @click="navTo(0);"><span style="--index:0">WELCOME</span></li>
          <li @click="navTo(1);"><span style="--index:1">CONFERENCE SCHEDULE</span></li>
          <li @click="navTo(2);"><span style="--index:2">SCIENTIFIC PROGRAM</span></li>
          <li @click="navTo(3);"><span style="--index:3">SPEAKERS</span></li>
          <li @click="navTo(4);"><span style="--index:4">CLINICAL CASE COMPETITION</span></li>
          <li @click="navTo(5);"><span style="--index:5">CONFERENCE MAP</span></li>          
          <li @click="navTo(6);"><span style="--index:6">REGISTRATION</span></li>
        </ul>
    </div>

    <!-- top nav -->
    <div class="topBar" id="topbar1">
      <img class="topLogo" src="/img/palma/logo_palma.png" alt="" />
    </div>    

    <!-- target="_blank" -->
    <a target="_blank" class="menuReg" href="https://web.cvent.com/event/bdfd78f5-cffd-41e3-8bae-d2ae73158323/register?RefId=MISCONFREG&rp=2ed1ffd3-005e-4650-b57d-729bc2aac6c4">
      <span>
        Register <i class="fal fa-chevron-right"></i>
      </span>
    </a>

    <!-- menu toggle -->
    <div class="menuOpen" @click="openMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>


    <!-- sections -->
    <main>
      <section id="hpStart" class="siteSection no-parallax __blue-grad hpBg fixed-bg">
        <home-start></home-start>
      </section>

      <!-- AGENDA -->
      <section id="hpAgenda" class="siteSection bgSchedule no-parallax reveal">        
        <home-agenda @show-program="showProgram"></home-agenda>
      </section>

      <!-- PROGRAM -->
      <section id="hpProgram" class="siteSection disabledSection no-parallax reveal bgProg">        
        <home-prog @showprogramitem="showProgramItem" ></home-prog>
      </section>

      <!-- SPEAKERS -->
      <section id="hpSpeakers" class="siteSection disabledSection no-parallax reveal bgSpeakers">        
        <home-speakers 
          @show-speaker="showSpeaker" 
          @show-guest="showGuest"          
          @show-com="showCom"></home-speakers>
      </section>

      <!-- COMPETITION -->
      <section id="hpCompetition" class="siteSection no-parallax reveal bgComp">                
        <home-competition @show-compcom = "showCompCom"></home-competition>
      </section>

      <!--MAP -->
      <section id="resort1" class="siteSection reveal bgMap">        
        <!-- <home-connect @open-gal="openGal" @open-map="openMap"></home-connect> -->
        <home-hotels></home-hotels>
      </section>


      <!-- Register -->
      <section id="hpRegistration" class="siteSection no-parallax reveal bgRegister">
        <home-reg></home-reg>
      </section>

      <!--
      <section class="no-parallax reveal white">
        <home-boxes></home-boxes>
      </section>-->


    </main>


  </div>
</template>

<style>
.topBar
{
  pointer-events: none;
  position: fixed;
  z-index:100;
  top:0px;left:0px;
  width: 100vw;
  height: 120px;
  display: grid;
  align-items: center;
  padding: 0px 30px;
}
.topBar .topLogo
{
  width: 150px;height: auto;    
  padding-top:30px;
  padding-left:10px;
  
}
.menuOpen
{
    width:40px;height:24px;
    position: fixed;
    top: 40px;
    right: 40px; 
    opacity:0.4;
    cursor:pointer !important;  
    z-index:1000;  
}
.menuOpen span
{
    width: 100%;height:2px;background-color: #fff;position: absolute;top:0px;cursor:pointer;
    pointer-events: none;
}
.menuOpen span:nth-child(1){top:0px;}
.menuOpen span:nth-child(2){top:12px;}
.menuOpen span:nth-child(3){top:24px;}


.menuReg
{
    cursor:pointer !important;  
    top:37px;
    height: 30px;
    padding: 0 16px;
    position: fixed;
    right: 100px;     
    z-index:100; 
    border-radius: 30px;
    display: flex;
    align-items: center;    
    background-color: #ec709c;
    background-image: linear-gradient( 90deg, rgba(177, 45, 96, 0.996) 0%, rgb(236,139,107) 100%);
    transition: all ease 0.3s;
}
.menuReg span
{  
  color:#fff;font-size:12px;
  font-weight: 500 !important;
}
.menuReg span i
{
  font-weight: 500 !important;
  font-size: 11px;
  padding-left: 2px;
}
.menuReg:hover
{
  padding: 0 20px;
}



main {
  __height: 100vh;
  perspective: 2px;
  overflow-x: hidden;
  overflow-y: auto;  
}

section {
  transform-style: preserve-3d;
  position: relative;
  min-height: 100vh;
  color: white;
}
.disabledSection
{
  pointer-events: none !important;
}





.fixed-bg
{
  width: 100%;
  position:relative;
  display: flex;
  align-items: center;  
  background-color: #0d3553;
}
.fixed-bg::before 
{
  z-index:-10;
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background-repeat: no-repeat;
  background-position:center;
  background-attachment:fixed;
  background-size: cover;
}

.hpBg
{
  background-color: #000 !important;
}
.hpBg::before 
{
  opacity: 1 !important;
  background-position: top center;
  background-size: cover;
  background-image: url('/img/palma/BG-intro.jpg');  
}

.bgMap
{
  /* background-color: #041f34 !important; */
  background-color: #fff !important;
  padding: 0px !important;
  min-height: 0px;
  height: 100vh;
}
.bgComp
{
  background-color: #000;
  padding: 100px 0px;  

/*     background-image: url('/img/competition_bg.jpg') !important;
    background-size:cover;
    position: relative;  
    background-attachment:fixed;
 */
 }
._____fixed-bg.bgComp:before {
  content: "";
  position: absolute;
  left: 0; right: 0;
  top: 0; bottom: 0;
  background:#000;
  width: 100%;
  opacity: 0.8 !important;
}

.______fixed-bg.bgConnect::before 
{
  opacity: 1;
  background-image: url('/img/cancun/hotel-pool.jpg') !important;
  transition: ease-in all 0.9s;
}
._____reveal.active.fixed-bg.bgConnect::before 
{
  opacity: 0.4 !important;
}
.bgProg
{
  padding: 100px 0px;
  background-color: #f8f8f8 !important;
  position: relative;
  height: auto;
  color: white;  
}

.bgRegister,
.bgSchedule
{
  background-color: #1778bb !important;  
  height: auto !important;
  padding: 100px 0px;  
}
.bgSpeakers
{
  background-color: #1f2849 !important;
  height: auto !important;
  padding: 100px 0px;  
}






.no-parallax {  
  z-index: 999;
  display: flex;
  align-items: center;
}
.no-parallax.white
{
  background-color:#fff;
  width: 100%;
}
.no-parallax.black
{
  background-color:#000;
  width: 100%;
}

section h1 {
  text-align: center;
  font-size: 4rem;
  font-family: sans-serif;
}

.parallax
{
  display: flex;
  align-items: center;
}
.parallax h1 {
  width: 60%;
  font-size: 2rem;
}

.parallax::after {
  content: " ";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateZ(-1px) scale(1.5);
  background-size: 100%;
  z-index: -1;
}

.bg::after {
  background: linear-gradient(rgba(5, 30, 50, 0.9), rgba(5, 30, 50, 0.9));
}


.blue-grad
{ 
    background-color: #0076c0;
    background-image: linear-gradient(23deg, #013f66 28%, #0076c0);  
}

  @media (max-width: 850px) { 
    .topBar
    {
      height: 80px;
      padding: 0px 22px;      
      transition: all ease 0.3s;
    }    
    .topBar.opaq
    {
      background-color: rgba(0,0,0,0.5);
    }
    .topBar .topLogo
    {
      width: 80px;position:relative;top:-12px;left: -8px;
    }    
    .menuOpen
    {
        top:30px;
        width:34px;height:24px;right:25px;
    }
    .menuReg
    {
      top:27px;
      right:80px;
    }
    section 
    {
        height: auto !important;
        min-height: 100vh;
        padding: 100px 0px 100px 0px;  
    }
    .fixed-bg::before 
    {
      background-size:auto 100vh !important;
      background-attachment:initial !important;
      background-size: cover !important;
    }    

      .bgMap
      {
        min-height: 100vh;
        height: auto;
      }


  }


    .section-title,
    .split-text.section-title
    {
      font-size: clamp(40px,3vw,80px) !important;   
      line-height: clamp(40px,3.5vw,80px) !important;  
      letter-spacing: -1px;  
      padding-bottom: 0px;
      font-weight: 200 !important;
    }

    .fs20{font-size:20px !important;}
    .fs16{font-size:16px;}
    .fs14{font-size:14px;}
    .fs12{font-size:12px;}


    .split-text.subtitle .xLine .xLineText
    {
      font-weight: 200 !important;
    }
    .split-text.title .xLine .xLineText
    {
      font-weight: 200 !important;
    }

    /* ------------ Active animations ------------*/
    .reveal.active .xLineText
    {      
        animation-delay: calc(0.14s * var(--line_index)) !important;
        animation:xSlideTextUp 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;        
    }
    .reveal.active .xrImgCircle
    {
        animation-delay: calc(1s + 0.1s * var(--index)) !important;
        animation: cirImgOpenBase 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;        
    }
    .reveal.active .xrImgCircle .xrImg
    {
        animation-delay: calc(0.1s * var(--index)) !important;
        animation: cirImgOpen 3.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;
    }    
    .reveal.active .animation_up
    {
        animation:xSlideBtnUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;
        -webkit-animation-delay: 1.8s;
        animation-delay:1s;
    }
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/ 

    
</style>


<style lang="stylus">  
  .container
    width 50%
    text-align:center
    +below(815px)
      width 80%
  .split-text
    margin auto
    color #fff
    //width 100%
    //font-size 20px
    line-height 26px
    +below(815px)
      font-size 16px
      line-height 18px
    &.title
      font-size 40px
      line-height 48px
      letter-spacing -1px
      padding-bottom 0px
      +below(815px)
        font-size 30px
        line-height 40px
    &.subtitle
      font-size 24px
      line-height 28px
      letter-spacing -1px
      padding-bottom 15px
      +below(815px)
        font-size 20px
        line-height 26px        
  .xLine
    overflow hidden
    border solid 0px red    
  .xLineText
    position relative 
    top 0px
    //letter-spacing -1px !important
    opacity 0
    //animation xSlideTextUp 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    //animation-fill-mode forwards
    
</style>



<script>
import { mapActions, mapState } from "vuex";
import hpBox from './hp/hpBox.vue';
import { splitLines }         from "@/utils";
import HomeSection from "@/views/hp/hpSection1.vue";
import HomeConnect from "@/views/hp/hpConnect.vue";
import HomeBoxes from "@/views/hp/hpBoxes.vue";
import HomePros from "@/views/hp/hpPros.vue";
import HomeStart from "@/views/hp/hpStart.vue";
import HomeAgenda from "@/views/hp/hpAgenda.vue";
import HomeHotels from "@/views/hp/hpHotels.vue";
import HomeReg from "@/views/hp/hpRegister.vue";
import HomeSpeakers from "@/views/hp/hpSpeakers.vue";
import HomeProg from "@/views/hp/hpProg.vue";
import HomeProgram from "@/views/hp/hpProgram.vue";
import HomeLocation from "@/views/hp/hpLocation.vue";
import HomeProginfo from "@/views/hp/hpProginfo.vue";
import HomeGallery from "@/views/hp/hpGallery.vue";
import HomeCompetition from "@/views/hp/hpCompetition.vue";


import SpeakerInfo from "@/views/hp/hpSpeakerInfo.vue";
import site_data from "@/site_data.json";

// @ is an alias to /src
export default {
  components: {HomeGallery,HomeCompetition,HomeProg,HomeProginfo, HomeLocation,HomeProgram,HomeSpeakers,SpeakerInfo,HomeStart,HomeAgenda,HomeReg,hpBox,HomeSection,HomeConnect,HomeBoxes,HomePros,HomeHotels },
  name: "home",
    data() {
      return {
        topbar1:null,
        compVideo:'',        
        speakers:site_data[1].SPEAKERS,
        //popupMode:-1, //1:Program
        isProginfoOpen:false,
        progItemInfo:null,
        isMapOpen:false,
        isGalOpen:false,
        isMenuOpen:false,
      galOpenInex:-1,  
      speakerIndex:-1,
      speakerMode:'speaker',
      midBoxesW:400,
      slider: null,
      boxes: null,
      code: "",
      logoReady: false,
      logoMove: false,
      animateLogo: false,
      sloganReady: false,
      animateLetters: false,
      ro: null,
      elementSizes: [],
      resizeTrig: -1,
      observed: null
    };
  },
  watch: {
    pageLayoutData() {
      // console.log("PAGE DATA IS HERE: ", this.pageLayoutData);
      this.setPageReady(true);
    },
  },
  created() {
    //this.setPageReady(false);    
    this.initScrollListener();


  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  async mounted() {
    var vm = this;
    vm.topbar1 = document.getElementById("topbar1");
//    setTimeout(() => {
      vm.initText();  
  //  }, 5200);
    
    this.initRouteByPath(`Home/${this.$route.params.locale || "global"}`);


  },
  methods: {
    ...mapActions(["initRouteByPath", "setPageReady", "dirtifyHome"]),
    closeProgInfo()
    {
      this.isProginfoOpen=false;
    },
    openMap()
    {
      this.isMapOpen=true;
    },
    openGal()
    {
      //this.isGalOpen=true;
      this.galOpenInex=0;
    },
    closeMap()
    {
      this.isMapOpen=false;
    },
    closeGal()
    {
      this.galOpenInex=-1;
      //this.isGalOpen=false;
    },
    showProgram()
    {
      //this.popupMode=1;//Program
    },
    showProgramItem(item)
    {
      //alert("opening program info now");

      this.progItemInfo=item;//pass the item to the program item Info
      this.isProginfoOpen=true; //open the popup
      //alert("xxxxx:"+item[2]);//+item);
    },
    showSpeaker(index)
    {
      this.speakers=site_data[1].SPEAKERS;
      this.isMenuOpen=false;
      this.speakerIndex = index;   
      this.speakerMode = 'speaker';
    },
    showCom(index)
    {
      this.speakers=site_data[1].COMMITTEE;
      this.isMenuOpen=false;
      this.speakerIndex = index;      
      this.speakerMode = 'com';
    },
    showCompCom(index)
    {
      //alert("showCompCom="+index);
      this.speakers=site_data[1].COMPETITION.committee;
      this.isMenuOpen=false;
      this.speakerIndex = index;      
      this.speakerMode = 'comp';
    },
    showGuest(index)
    {
      this.speakers=site_data[1].GUEST;
      this.isMenuOpen=false;
      this.speakerIndex = index;      
      this.speakerMode = 'guest';
    },
    closeSpeaker()
    {
      this.speakerIndex = -1;
    },
    preSpeaker()
    { 
      if(this.speakerIndex > 0){
        this.speakerIndex--;
      }else{
        this.speakerIndex=this.speakers.length-1;
      }
    },
    nextSpeaker()
    {
      if(this.speakerIndex < this.speakers.length-1){
        this.speakerIndex++;
      }else{
        this.speakerIndex=0;
      }
    },
    openMenu()
    {
      this.speakerIndex = -1;      
      this.isMenuOpen=true;
    },
    navTo(index)
    {
      this.isMenuOpen=false;
      document.getElementsByClassName("siteSection")[index].scrollIntoView({ 
        behavior: 'smooth' 
      });
    },
    initScrollListener() {

      var vm = this;
      setTimeout(() => {
        vm.compVideo = document.querySelector("#compVideo1"); 
        vm.compVideo.setAttribute("playsinline", "");
        vm.compVideo.setAttribute("muted", "");
      }, 1500);


      window.addEventListener("scroll", this.scrollHandler, false);
    },
    scrollHandler() {
      this.pageScrollTop = document.documentElement.scrollTop;
      this.revealElements();
    },
    revealElements() 
    {
      var vm=this;
      var reveals = document.querySelectorAll(".reveal");
      for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 350;
        if (elementTop < windowHeight - elementVisible) 
        {
          if(reveals[i].classList.contains("active")==false)
          {
            vm.onRevealingSection(reveals[i].id);
            reveals[i].classList.add("active");
          }
          if(i>1){
            vm.topbar1.classList.add("opaq");
          }else{
            vm.topbar1.classList.remove("opaq");
          }
        } else {
          //reveals[i].classList.remove("active");
        }
      }
    },
    onRevealingSection(sectionID)
    {
      if(sectionID=='hpSpeakers' || sectionID=='hpProgram')
      {
        //Add delay to enable this section
        //this is to avoid mouse colloision on circles animations
        setTimeout(() => {
          let sectionElement = document.getElementById(sectionID);
          sectionElement.classList.remove("disabledSection");
        }, 400);
      }
      if(sectionID=='hpCompetition'){
        this.compVideo.play();
      }
    },
    initText()
    {      
      var splitBlocks = document.getElementsByClassName('split-text');
      for (var i = 0; i < splitBlocks.length; i++) {
        splitLines(1,splitBlocks[i],'xLine','xLineText'); 
        }
    },
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>

<style lang="stylus" scoped>
.fade-from-top
  &-enter-active
  &-leave-active
    transition opacity 2s ease-out, transform 2s ease-out-cubic
  &-enter
  &-leave-to
    transform translateY(-50%) !important
  &-enter-to
  &-leave
    opacity 1 !important
    transform translateY(0) !important
.home
  position relative
  //top 33px
  min-height 120vh
  .mis-promo
    // padding 60px 0
    // +below(768px)
    padding 44px 0
    +below(415px)
      _flex(row, wrap, center, center)
      padding 30px 0
  h2
    height 100%
    min-height 70px
    min-width 34vw
    position relative
    _flex(row, nowrap, baseline, center, true)
    +below(1100px)
      _flex(row, nowrap, flex-bottom, center, true)
      min-height auto
    .slogan-box
      color blue_primary
      border-left 1px solid blue_primary
      background #fff
      font-size responsive 27px 52px
      font-weight 500
      opacity 0
      overflow hidden
      & >>> .letter
        opacity 0
        display inline-block
        transform translateY(100%)
        position relative
        font-weight 300 !important
    &.logo-move
      .mis-logo
        left 0
        transform translateX(0)
    &.logo-ready
      .slogan-box.animate
        opacity 1
        & >>> .letter
          opacity 1
          transform translateY(0)
    &.next
      .mis-logo
        position static
        +below(1100px)
          height auto
        +below(415px)
          height 27px
  h3
    font-size responsive 14px 28px
    color gray_8
    &.logo-extra
      opacity 0
      transform translateY(-50%)
      transition opacity 0.4s ease-out, transform 0.4s ease-out
      &.show
        opacity 1
        transform translateY(0)
</style>


<!-- general styles -->
<style>
  body::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
  .white_btn
  {
    opacity:0;
    cursor: pointer;
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    color: #fff !important;
    border: 1px solid #ddd;
    text-align: left;
    background-color:transparent;
    padding: 25px 25px;
    border-radius: 40px;
    height: 40px;
    font-size: 14px;    
  }
  .white_btn span
  {
    line-height: 1;
    display: inline-block;
    vertical-align: middle;    
    font-weight: 300 !important;
  }
  .base_btn
  {
    opacity:0;
    cursor: pointer;
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    text-align: left;
    padding: 25px 25px;
    border-radius: 40px;
    height: 40px;
    font-size: 16px;    
  }
  .base_btn span
  {
    line-height: 1;
    display: inline-block;
    vertical-align: middle;    
    font-weight: 300 !important;
  }
  .reg_btn
  {
    color: #fff !important;
    cursor:pointer !important;  
    background-color: #ec709c;
    background-image: linear-gradient( 90deg, rgba(177, 45, 96, 0.996) 0%, rgb(236,139,107) 100%);
    transition: all ease 0.4s;
  }
  .reg_btn:hover
  {
    padding-left:36px;
    padding-right:36px;
  }

  .orange_btn
  {
    color: #fff !important;
    border: 1px solid #e29b3d !important;
    background-color:#e29b3d !important;
  }
  .orange_btn:hover
  {
    color: #fff !important;
    border: 1px solid #fff !important;
    background-color:transparent !important;
  }


  .xrBtn
  {
    padding-top:30px;color:#fff;
    width:auto;
    margin:auto;text-align:center;
    align-items: center;
    display: inline-flex;

  }
  .xrBtns
  {
    padding-top:30px;color:#fff;
    width:400px;margin:auto;text-align:center;
    display: grid;
    align-items: center;
    column-gap: 20px;
    justify-items: center;
    grid-template-columns: 1fr 1fr;
  }

  /* menu */
  .msMenu
  {
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      background-color: #fff;
      z-index: 1000;
      display: grid;
      align-items: center;
      text-align: center;
      opacity: 0;
      /* clip-path: inset(0px 0px 100% 0px); */
      transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      pointer-events: none;
  }
  .msMenu.msOpen
  {
      pointer-events: all;
      opacity: 1;
      /* clip-path: inset(0px 0px 0px 0px); */
  }
  .msMenu .closebtn
  {
    position: absolute;top: 3vh;right:3vh;z-index: 2000;
  }
  .msMenu ul
  {
    list-style: none;
    padding:0px;
  }
  .msMenu ul li
  {
    cursor: pointer;
    line-height: 50px;
    font-weight: 400 !important;
    letter-spacing: -1px !important;
    overflow: hidden;
    opacity: 0.8;
  }
  .msMenu ul li:nth-child(1) span{color:#652a81 !important;}
  .msMenu ul li:nth-child(2) span{color:#d41528 !important;}
  .msMenu ul li:nth-child(3) span{color:#eb6b41 !important;}
  .msMenu ul li:nth-child(4) span{color:#4fb9a6 !important;}
  .msMenu ul li:nth-child(5) span{color:#37ab69 !important;}
  .msMenu ul li:nth-child(6) span{color:#36aade !important;}

  .msMenu ul li span
  {
    cursor: pointer !important;
    font-size: 30px;
    line-height: 50px;
    font-weight: 400 !important;
    letter-spacing: -1px !important;
    position: relative;
    top: 0px;
    text-transform: uppercase;
  }

  @media only screen and (min-width: 1800px) 
  {
    .base_btn,
    .white_btn
    {
      padding: 30px 30px;
      border-radius: 60px;
      height: auto;
      font-size: clamp(14px, 1.2vw, 24px);    
    }
    .topBar .topLogo
    {
      padding-left: 1.5vw;
      padding-top: 1.5vw;
      width: 10vw;
      height: auto;    
    }    
    .fs20{
      font-size: clamp(20px, 1.3vw, 36px) !important;
    }
    .fs16{
      font-size: clamp(16px, 1.2vw, 30px) !important;
    }
    .fs14{
      font-size: clamp(14px, 1vw, 24px) !important;
    }
    .fs12{
      font-size: clamp(12px, 0.8vw, 20px) !important;
    }
  }  

  @media only screen and (min-width: 2200px) 
  {
    .menuOpen
    {
      top:42px;
    }
    .menuReg
    {
      height: auto;padding: 10px 24px;   
      top: 32px;   
    }
    .menuReg span
    {  
      font-size: 22px !important;
    }    
    .menuReg span i {
      font-size: 22px;
    }    
  }

  @media (hover: hover) {
    .msMenu ul li:hover{
      cursor: pointer !important;
      opacity: 1;
    }
    .white_btn
    {
      transition: all ease-in 0.2s;      
    }
    .white_btn:hover
    {
      background-color: #fff;
      color:#202020;
    }
    .white_btn:hover i,
    .white_btn:hover span{
      color:#202020 !important;
    }
  }



  @media (max-width: 850px) { 
    .xrBtns
    {
      width:90vw;
      column-gap: 10px;
    }    
    .msMenu ul li
    {
      opacity: 1;
    }
    .msMenu ul li span
    {
      font-size: 26px;
      line-height: 50px;
      font-weight: 400 !important;
      letter-spacing: -1px !important;
    }    
  }


  @media only screen and (min-width: 1024px) and (max-height: 1366px)
      and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none) {
      /* ipad pro ... */
      .fixed-bg::before 
      {
        background-attachment:scroll;
      }
  }

  @media only screen and (min-width: 1024px) 
      and (max-height: 1366px)
      and (-webkit-min-device-pixel-ratio: 1.5) 
      and (hover: none) 
      and (orientation: portrait) {
      .bgMap
      {
        min-height: 1px;
        height: 60vh;
      }
  }

  

  

  @media only screen and (max-width: 1024px) {
    .fixed-bg::before 
    {
      background-attachment:scroll;
    }
  }




</style>